import { Component, inject } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { ImagePreviewService } from '@/app/services/image-preview.service';

/**
 * Global large-image lightbox. Mounted once (in the app layout); shows whatever
 * {@link ImagePreviewService} currently holds. Click the mask or the close icon
 * to dismiss. Use `ImagePreviewService.open(url)` from anywhere to trigger it.
 */
@Component({
    selector: 'app-image-preview',
    standalone: true,
    imports: [Dialog],
    template: `
        <p-dialog
            [visible]="!!preview.current()"
            (visibleChange)="onVisibleChange($event)"
            [modal]="true"
            [draggable]="false"
            [dismissableMask]="true"
            [closeOnEscape]="true"
            appendTo="body"
            [style]="{ width: 'auto', maxWidth: '94vw' }"
            contentStyleClass="p-2"
        >
            @if (preview.current(); as p) {
                <img
                    [src]="p.url"
                    [alt]="p.alt"
                    class="block mx-auto max-w-[90vw] max-h-[82vh] object-contain"
                />
            }
        </p-dialog>
    `,
})
export class ImagePreview {
    protected readonly preview = inject(ImagePreviewService);

    protected onVisibleChange(value: boolean): void {
        if (!value) this.preview.close();
    }
}
